import { render, staticRenderFns } from "./dsh.vue?vue&type=template&id=627da29a&scoped=true&"
import script from "./dsh.vue?vue&type=script&lang=js&"
export * from "./dsh.vue?vue&type=script&lang=js&"
import style0 from "./dsh.vue?vue&type=style&index=0&id=627da29a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627da29a",
  null
  
)

export default component.exports